export default {
	"4 quadrants": "Ячейки",
	"Airplane": "Самолет",
	"Alert": "Предупреждение",
	"Arrow Decrease": "Стрелка вправо-вниз",
	"Arrow Increase": "Стрелка вправо-вверх",
	"Audience": "Аудитория",
	"Avatar": "Аватар",
	"Bar Graph": "Гистограмма",
	"Brightness": "Яркость",
	"Bubble Plot": "Кружки в квадрате",
	"Building": "Строительство",
	"Calendar Accepted": "Календарь с галочкой",
	"Calendar Declined": "Календарь с крестиком",
	"Calendar": "Календарь",
	"Call": "Телефон",
	"Camera": "Камера",
	"Capital": "Столица",
	"Center Map": "Прицелл",
	"Change": "Обмен",
	"Circle Checkmark": "Галочка в круге",
	"Circle Delete": "Крестик в круге",
	"Circle Minus": "Минус в круге",
	"Circle More": "Три точки в круге",
	"Circle Plus": "Плюс в круге",
	"Clinic": "Клиника",
	"Close": "Крестик",
	"Cloud": "Облако",
	"Comment": "Комментарий",
	"Community": "Люди",
	"Confirmed": "Успешно",
	"Convert": "Конвертация",
	"Delete": "Корзина",
	"Desktop Computer": "Компьютер",
	"Digital Tech Transformation": "Шестеренка в компьютере",
	"DOC": "Doc",
	"Door Closed": "Закрытая дверь",
	"Door Open": "Открытая дверь",
	"Down Chevron Circle": "Стрелка вниз в кружке",
	"Down Chevron": "Стрелка вниз",
	"Download Save": "Загрузить 1",
	"Download Simple": "Загрузить 2",
	"Download": "Загрузить 3",
	"Downtrend": "Треугольник вниз",
	"Duplicate": "Копировать",
	"Edit": "Правка",
	"Email": "Письмо",
	"End Process": "Запрет",
	"Entrepreneur": "Share",
	"Expand": "Выделение",
	"F&B": "Коктейль",
	"Family": "Семья",
	"File": "Файл",
	"Filter": "Фильтр",
	"Folder Open": "Папка 1",
	"Folder": "Папка 2",
	"Globe": "Глобус",
	"Governance": "Весы",
	"Grid View": "Сетка",
	"Grow Revenue": "Рост показателей",
	"Growth": "Росток",
	"Heart": "Сердце",
	"Help Question": "Помощь",
	"Home": "Дом",
	"Hook": "Галочка",
	"Horizontal More": "Многоточие",
	"Hospital": "Госпиталь",
	"Icon Spinner": "Loader",
	"ID card": "Документ",
	"Image": "Изображение",
	"Infinity loop": "Бесконечность",
	"Information": "Информация",
	"Leader": "Лидер",
	"Left Chevron Circle": "Стрелка влево в круге",
	"Left Chevron": "Стелка влево",
	"List View-1": "Таблица",
	"List View": "Маркированный список",
	"Location Locked": "Замок в прицеле",
	"Location": "Метка карты",
	"Login": "Вход",
	"Logout": "Выход",
	"Management": "Портфель",
	"Mark": "Закладка",
	"Menu View": "Меню 1",
	"Menu": "Меню 2",
	"Minimize": "Уменьшить",
	"Minus": "Минус в круге",
	"Move": "Сдвиг",
	"New User": "Новый пользователь",
	"News": "Лист А4",
	"Notifications": "Уведомления",
	"Partnership": "Партнерство",
	"Pause": "Пауза",
	"PDF": "PDF",
	"Person": "Человек",
	"Physician": "Врач",
	"Pie Chart": "Круговая диаграмма",
	"Play": "Play",
	"Plus": "Плюс",
	"PPT": "PPT",
	"Printer": "Принтер",
	"Profitability": "Рентабельность",
	"Purpose": "Цель",
	"Radio": "Круг в круге",
	"Refresh": "Обновление",
	"Revenue": "Растущая диаграмма",
	"Right Chevron Circle": "Стрелка вправо в круге",
	"Right Chevron": "Стрелка вправо",
	"Save": "Сохранить",
	"Search": "Поиск",
	"Service": "Обслуживание",
	"Settings": "Настройки",
	"Share 1": "Опубликовать",
	"Share 2": "Поделиться",
	"Shopping Bag": "Пакет",
	"Shopping Cart": "Корзина",
	"Sort Ascent": "Сортировка вверх",
	"Sort Default": "Сортировка",
	"Sort Descent": "Сортировка вниз",
	"Spark Line": "Диаграмма",
	"Spiderchart": "Паутина",
	"Star": "Звезда",
	"Stewardship": "Управление",
	"Survey": "Анкета",
	"Table Data": "Дарц",
	"Talent": "Фокусировка",
	"Thumbs Up": "Лайк",
	"Ticket": "Талон",
	"Time": "Часы",
	"Toggle": "Тумблер",
	"Transform": "Преобразование",
	"Up Chevron Circle": "Шеврон в круге",
	"Up Chevron": "Шеврон вверх",
	"Upload Simple": "Простая загрузка",
	"Upload": "Загрузка",
	"Uptrend": "Треугольник вверх",
	"Vait": "Песочные часы",
	"Vertical More": "Подробнее",
	"View": "Просмотр",
	"Visitor": "Посетитель",
	"Volume Down": "Тихий динамик",
	"Volume Off": "Динамик без звука",
	"Volume Up": "Громкий динамик",
	"Wealth": "Деньги",
	"XLS": "XLS"
};